/* eslint-disable import/prefer-default-export */
/* eslint no-shadow: ["error", {"allow": ["state"]}] */
/* eslint no-param-reassign: ["error", { "props": true,
                                        "ignorePropertyModificationsFor": ["state"] }] */
import Vue from 'vue';

import procurementService from '../_services/procurement.service';

const state = {
  projects: [],
  projects_stats: {},
  filters: {
    only_active: false,
    submission_deadline: "",
    location: {
      country: "ES",
      postal_codes: [],
      cities: []
    },
    contracting_parties: [],
    amount: {
        from: "",
        to: ""
    },
    date: {
        from: "",
        to: "",
        years: []
    },
    lot_division: "all",
    cpv_codes: [],
    contract_types: [],
    status: [],
    awardee_parties: []
  },
  party_subscriptions: [],
  project_subscriptions: [],
  searchTerms: '',
  searching: false,
  total_results: 0,
  current_page: 1,
  total_pages: 0,
  currentSortField: 'publication_date',
  currentSortOrder: 'desc',
  newSearchFlag: true,
  updateFiltersUI: false,
  currentTab: 0,
};

const actions = {
  changePage({ dispatch }, page) {
    dispatch('search', {
      searchTerms: state.searchTerms,
      newSearchFlag: false,
      page,
      sortField: state.currentSortField,
      sortOrder: state.currentSortOrder,
    });
  },
  createPartySubscription({ dispatch }, { id }) {
    return procurementService.createProcurementPartySubscription({ id }).then(
      () => {
        dispatch('getPartySubscriptions');
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  createProjectSubscription({ dispatch }, id) {
    return procurementService.createProcurementProjectSubscription(id).then(
      () => {
        dispatch('getProjectSubscriptions');
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  deletePartySubscription({ dispatch }, id) {
    return procurementService.deleteProcurementPartySubscription(id).then(
      () => {
        dispatch('getPartySubscriptions');
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  deleteProjectSubscription({ dispatch }, id) {
    return procurementService.deleteProcurementProjectSubscription(id).then(
      () => {
        dispatch('getProjectSubscriptions');
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  getPartySubscriptions({ commit }) {
    return procurementService.getProcurementPartySubscriptions().then(
      (response) => {
        const { party_subscriptions } = response.data;
        commit('storePartySubscriptions', {
          party_subscriptions,
        });
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  getProjectSubscriptions({ commit }) {
    return procurementService.getProcurementProjectSubscriptions().then(
      (response) => {
        const { project_subscriptions } = response.data;
        commit('storeProjectSubscriptions', {
          project_subscriptions,
        });
      },
    ).catch((error) => {
      console.log(error);
    });
  },
  search({ commit, dispatch }, {
    searchTerms, newSearchFlag = true, page = 1, sortField = 'score', sortOrder = 'desc',
  }) {
    commit('setSearching', true);
    commit('setSearchTerms', { searchTerms, newSearchFlag });

    // console.log('Searching procurements with terms:', searchTerms);
    // console.log('Filters:', state.filters);
    const params = {
      searchTerms,
      page,
      sortField,
      sortOrder,
      filters: {
        ...state.filters,
      },
    };

    // We return the promise from axios so that the view will now when the data has loaded
    // eslint-disable-next-line consistent-return
    return procurementService.search(params).then(
      (response) => {
        const { results, aggs } = response.data;
        const { total_results, total_pages, current_page } = response.data.metadata;
        commit('storeProjects', {
          projects: results, total_results, total_pages, current_page, sortField, sortOrder, aggs,
        });
      },
    ).catch((error) => {
      console.log(error);
      dispatch('flashMessages/error', { message: 'empty', i18nArgs: { content: 'Se ha producido algún error. Por favor, inténtelo de nuevo más tarde' } }, { root: true });
      commit('storeProjects', { projects: [], total_results: 0 });
    }).finally(() => {
      commit('setSearching', false);
    });
  },
  setFilters({ commit, dispatch }, { filters }) {
    console.log('Setting filters:', filters);
    commit('storeFilters', { filters });
    dispatch('search', { searchTerms: state.searchTerms, newSearchFlag: false });
  },
};

const mutations = {
  setSearchTerms(state, { searchTerms, newSearchFlag }) {
    state.searchTerms = searchTerms;
    state.newSearchFlag = newSearchFlag;
  },
  setSearching(state, searching) {
    state.searching = searching;
  },
  storeFilters(state, { filters }) {
    Vue.set(state, 'filters', filters);
  },
  storeProjects(state, {
    projects, total_results, total_pages, current_page, sortField, sortOrder, aggs,
  }) {
    state.total_results = total_results;
    state.total_pages = total_pages;
    state.current_page = current_page;
    state.currentSortField = sortField;
    state.currentSortOrder = sortOrder;

    Vue.set(state, 'projects', projects);
    if (current_page === 1 && aggs) {
      Vue.set(state, 'projects_stats', aggs);
    }
  },
  storePartySubscriptions(state, { party_subscriptions }) {
    Vue.set(state, 'party_subscriptions', party_subscriptions);
  },
  storeProjectSubscriptions(state, { project_subscriptions }) {
    Vue.set(state, 'project_subscriptions', project_subscriptions);
  },
  updateFiltersUI(state) {
    state.updateFiltersUI = !state.updateFiltersUI;
  },
  setCurrentTab(state, { tabIndex }) {
    state.currentTab = tabIndex;
  },
};

const getters = {
  filters_count() {
    let total_count = 1; // country always set
    if (state.filters.only_active) total_count += 1;
    if (state.filters.submission_deadline && state.filters.submission_deadline != "" ) {
      total_count += 1;
    }
    if (state.filters.location) {
      if (state.filters.location.postal_codes && state.filters.location.postal_codes.length > 0) {
        total_count += 1;
      }
      if (state.filters.location.cities && state.filters.location.cities.length > 0) {
        total_count += 1;
      }
      if (state.filters.location.years && state.filters.location.years.length > 0) {
        total_count += 1;
      }

    }
    if (state.filters.contracting_party && state.filters.contracting_party.name && state.filters.contracting_party.name != "") {
      total_count += 1;
    }
    if (state.filters.amount && state.filters.amount.from && state.filters.amount.from != "") {
      total_count += 1;
    }
    if (state.filters.amount && state.filters.amount.to && state.filters.amount.to != "") {
      total_count += 1;
    }
    if (state.filters.date && state.filters.date.from && state.filters.date.from != "") {
      total_count += 1;
    }
    if (state.filters.date && state.filters.date.to && state.filters.date.to != "") {
      total_count += 1;
    }
    if (state.filters.lot_division && state.filters.lot_division != "all") {
      total_count += 1;
    }
    if (state.filters.cpv_codes && state.filters.cpv_codes.length > 0) {
      total_count += 1;
    }
    if (state.filters.contract_types && state.filters.contract_types.length > 0) {
      total_count += 1;
    }
    if (state.filters.awardee_parties && state.filters.awardee_parties.length > 0) {
      total_count += 1;
    }
        if (state.filters.status && state.filters.status.length > 0) {
      total_count += 1;
    }
    return total_count;
  },
};

const procurementModule = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default procurementModule;
